<template>
  <div
    :class="$vuetify.breakpoint.width < 960 ? 'mb-4 wrap-channel-header' : 'mb-6 wrap-channel-header'"
    style="text-align: center; align-items: center; justify-content: center !important"
  >
    <v-row
      v-if="$store.getters.selectedCh"
      id="channelContainer"
      ref="channelContainer"
      no-gutters
      dense
      :class="
        $vuetify.breakpoint.width < 960 ? 'container-channel-header px-2 py-3' : 'container-channel-header px-3 py-5'
      "
      align="center"
      justify="center"
      style="justify-self: center"
    >
      <!-- Channel Icon Start -->
      <v-col
        v-if="chLogo"
        cols="auto"
        :class="$vuetify.breakpoint.width < 960 ? 'pl-3 pr-0 mb-2' : 'pl-5 pr-2 mb-2'"
        style=""
        align-self="center"
      >
        <div>
          <v-avatar
            :color="
              chLogo && chLogo !== ''
                ? 'transparent'
                : avatarColor(
                    computedSelectedCh.chTitle ||
                      computedUserInfo['userDisplayName'] ||
                      computedUserInfo['userFullName'] ||
                      'A'
                  )
            "
            class="logo`"
            round
            :size="$vuetify.breakpoint.width < 960 ? '50' : '100'"
          >
            <span
              :class="
                $vuetify.breakpoint.width < 1264
                  ? $vuetify.breakpoint.width < 960
                    ? 'white--text text-h3 cent'
                    : 'white--text text-h3 cent'
                  : 'white--text text-h2 cent'
              "
              v-if="!chLogo"
            >
              {{
                computedSelectedCh.chTitle ||
                computedSelectedCh.chCreatorInfo['userDisplayName'] ||
                computedUserInfo.chCreatorInfo['userFullName'] ||
                'A' | iconFilter
              }}
            </span>
            <v-img eager :src="chLogo" v-else>
              <template v-slot:placeholder>
                <v-sheet color="grey darken-1" class="fill-height">
                  <v-skeleton-loader class="mx-auto" type="image" width="250px"></v-skeleton-loader>
                </v-sheet>
              </template>
            </v-img>
          </v-avatar>
        </div>
      </v-col>
      <!-- Channel Icon End -->

      <!-- Channel Title, Buttons, Desc Start -->
      <v-col class="container-channel-info" cols="" align-self="start">
        <!-- Channel Title, Buttons Start -->
        <v-row no-gutters align="center" justify="space-between">
          <!-- Channel Title Start -->
          <v-col
            :cols="isWsManager || isWsOwner || computedSelectedCh.chPermission == computedUserInfo.userId ? '8' : '12'"
            class="container-channel-header-title"
          >
            <v-text-field
              class="channel-header-title font-weight-bold"
              v-model="computedSelectedCh.chTitle"
              :disabled="!isWsManager && !isWsOwner && computedSelectedCh.chPermission != computedUserInfo.userId"
              @blur="outFocus"
              @keyup.enter="outFocus"
              dark
              dense
              flat
              hide-details
              solo
              background-color="#111a1e"
              full-width
              :style="$vuetify.breakpoint.width < 960 ? 'padding: 0; font-size: 16px' : 'padding: 0; font-size: 20px'"
              placeholder="Untitled"
            ></v-text-field>
          </v-col>
          <!-- Channel Title End -->
          <!-- Channel Buttons Start -->
          <v-col
            v-if="isWsManager || isWsOwner || computedSelectedCh.chPermission == computedUserInfo.userId"
            cols="4"
            class="container-channel-header-title container-channel-header-btns"
            :style="$vuetify.breakpoint.width < 960 ? 'text-align: center' : 'text-align: right'"
          >
            <v-btn
              v-if="computedSelectedCh['receivingStatus'] == 'on'"
              dark
              plain
              class="btn-link"
              @click.stop="copyUrlToClipboard"
            >
              <v-icon>mdi-link-variant</v-icon>
              <!-- <span class="material-icons-round md-36 font-weight-light">link</span> -->
            </v-btn>
            <v-menu v-model="expandMenu" class="" offset-y bottom left dark>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  dark
                  plain
                  :style="
                    $vuetify.breakpoint.width < 960
                      ? 'font-size: 26px; width: 26px; min-width: 26px; padding: 0'
                      : 'width: 48px; min-width: 48px'
                  "
                  class="menu-channel-header"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span class="material-icons-round" translate="no">{{ expandMenu ? 'close' : 'more_horiz' }}</span>
                </v-btn>
              </template>
              <div class="container-menu-comment" style="background-color: #1d292f; overflow: hidden">
                <v-row align="center" justify="center" dense>
                  <v-col cols="12">
                    <v-btn
                      dark
                      block
                      plain
                      elevation="0"
                      class="btn-receive"
                      :color="computedSelectedCh['receivingStatus'] == 'on' ? '#37a278' : '#ffffff'"
                      @click="openDialog('Receiving')"
                    >
                      <span :style="$vuetify.breakpoint.width < 1264 ? 'font-size: 11px' : 'font-size: 13px'">
                        {{ computedSelectedCh['receivingStatus'] == 'on' ? 'Share' : 'Share' }}
                      </span>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" style="padding: 0 !important">
                    <v-divider dark style="display: block"></v-divider>
                  </v-col>
                  <v-col cols="12">
                    <v-btn dark block plain class="btn-icon" @click="openDialog('ChannelIcon')">
                      <span :style="$vuetify.breakpoint.width < 1264 ? 'font-size: 11px' : 'font-size: 13px'">
                        {{ 'Set icon' }}
                      </span>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-menu>
          </v-col>
          <!-- Channel Buttons End -->
        </v-row>
        <!-- Channel Title, Buttons End -->
        <!-- Channel Description Start -->
        <v-row
          no-gutters
          dense
          v-if="
            computedSelectedCh.chDescription ||
            isWsManager ||
            isWsOwner ||
            computedSelectedCh.chPermission == computedUserInfo.userId
          "
        >
          <v-col cols="12" class="channel-header-desc text-body-2">
            <v-textarea
              v-model="computedSelectedCh.chDescription"
              :disabled="!isWsManager && !isWsOwner && computedSelectedCh.chPermission != computedUserInfo.userId"
              v-show="
                isWsManager ||
                isWsOwner ||
                computedSelectedCh.chPermission == computedUserInfo.userId ||
                computedSelectedCh.chDescription
              "
              @blur="outFocus"
              @keyup.enter="outFocus"
              dark
              flat
              hide-details
              solo
              background-color="#111a1e"
              style="padding: 0 !important"
              auto-grow
              no-resize
              rows="1"
              dense
              placeholder="Add Channel Description"
              :key="autoGrowHack"
            ></v-textarea>
          </v-col>
        </v-row>
        <!-- Channel Description End -->
      </v-col>
      <!-- Channel Title, Buttons, Desc End -->
    </v-row>
    <receiving-setting
      v-if="isReceivingSetting"
      @close="closeDialog"
      :isReceivingSetting.sync="isReceivingSetting"
    ></receiving-setting>
    <channel-icon-setting
      v-if="isChannelIconSetting"
      @close="closeDialog"
      @changedChLogo="changeLogo($event)"
      :isChannelIconSetting.sync="isChannelIconSetting"
    ></channel-icon-setting>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ReceivingSetting from '@/views/modal/ReceivingSetting'
import ChannelIconSetting from '@/views/modal/ChannelIconSetting'
import { setChannelDetail } from '@/services/channelApi'
import { copy } from '@/common/common'
import { getShareUrl, setUserFunnel } from '@/services/api'
import Toast from '@/views/meeting/component/Toast'

export default {
  name: 'ChannelHeader',
  components: { ReceivingSetting, ChannelIconSetting },
  props: {},
  data() {
    return {
      isReceivingSetting: false,
      isChannelIconSetting: false,
      chTitle: '',
      chDescription: '',
      chLogo: null,
      autoGrowHack: false,
      expandMenu: false,
    }
  },
  created() {
    if (this.computedSelectedCh['chLogo']) {
      this.chLogo =
        this.computedSelectedCh['chLogo'].indexOf('timestamp') > -1
          ? this.computedSelectedCh['chLogo']
          : `${this.selectedCh['chLogo']}?timestamp=${new Date().getTime()}`
    }
  },
  mounted() {
    window.addEventListener('resize', this.forceReRender)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.forceReRender)
  },
  updated() {},
  computed: {
    ...mapGetters([
      'assignedInfo',
      'selectedWsInfo',
      'userInfo',
      'userName',
      'chList',
      'selectedCh',
      'isWsManager',
      'isWsOwner',
    ]),
    computedSelectedCh() {
      return this.selectedCh ?? {}
    },
    computedUserInfo() {
      return this.userInfo ?? {}
    },
    isChOwner() {
      return this.userInfo && this.selectedCh && this.userInfo['userId'] === this.selectedCh['chPermission']
    },
  },
  methods: {
    forceReRender() {
      this.autoGrowHack = !this.autoGrowHack
    },
    outFocus() {
      this.chTitle = this.computedSelectedCh['chTitle']
      this.chDescription = this.computedSelectedCh['chDescription']
      if (this.selectedCh['chType'] === 'W' && (this.isWsOwner || this.isWsManager)) this.updateChannel()
      else if (this.selectedCh['chType'] === 'P' && this.isChOwner) this.updateChannel()
    },
    avatarColor(value) {
      if (value === '') return null
      let color = ['#ff464f', '#ff8a34', '#ffbc25', '#27cd8b', '#005df2', '#6952dc']
      let index = 0

      if (value && value.length > 0) {
        for (let i = 0; i < value.length; i++) {
          index += value.charCodeAt(i)
        }
      }
      return color[index % 6]
    },
    changeLogo(result) {
      this.chLogo =
        result && result.chLogo && result.chLogo !== '' ? `${result.chLogo}?timestamp=${new Date().getTime()}` : ''
      if (this.selectedCh) this.selectedCh['chLogo'] = this.chLogo
      // result && result.chLogo && result.chLogo !== '' ? `${result.chLogo}?timestamp=${new Date().getTime()}` : ''
    },
    openDialog(type) {
      if (type === 'Receiving') {
        this.isReceivingSetting = true
      } else if (type === 'ChannelIcon') {
        this.isChannelIconSetting = true
      }
    },
    closeDialog(val) {
      if (val === 'Receiving') {
        this.isReceivingSetting = false
      } else if (val === 'ChannelIcon') {
        this.isChannelIconSetting = false
      }
    },
    async updateChannel() {
      try {
        await setChannelDetail(
          this,
          this.computedUserInfo.userId,
          this.selectedWsInfo.wsId,
          this.computedSelectedCh['chType'],
          this.computedSelectedCh['chId'],
          this.computedSelectedCh['chTitle'],
          this.computedSelectedCh['chDescription'],
          null,
          this.chLogo
        )
      } catch (error) {
        console.log('error ', error)
      }
    },
    async setSafariUrl() {
      let title = this.selectedCh.chTitle
      let content = ''
      let imgUrl = this.chLogo
      let routePayload = {
        name: 'Channel',
        params: {
          wsDomain: this.$route.params['wsDomain'],
          chId: this.selectedCh && this.selectedCh['chId'] ? this.selectedCh['chId'].replace('CH:', '') : '',
        },
      }
      let linkUrl = location.origin + this.$router.resolve(routePayload).href

      let copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)
      this.safariPath = copyUrl.shortLink
      this.safariPathWithClipId = copyUrl.shortLink
    },
    async copyUrlToClipboard() {
      let copyResult
      let safariUrl = this.clipValue ? this.safariPathWithClipId : this.safariPath
      if (this.isSafari && this.safariUrl !== null) {
        copyResult = await copy(safariUrl)
      } else {
        // Short Link 제거
        // await this.createShareUrl()
        // copyResult = await copy(this.path)

        copyResult = await copy(location.href)
      }

      if (copyResult) {
        this.checkFunnel()
        this.$store.dispatch('setFirebaseLog', {
          eventName: 'share',
          eventParam: {
            name: 'share',
            methodType: this.clipValue ? 'clip' : 'meeting',
          },
        })
        if (!this.isMobile) {
          // notify(this, 'Success', this.$t('copiedClipboardUrl'), 'success')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('copiedClipboardUrl'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
        }
      } else {
        // notify(this, 'Error', this.$t('failedCopy'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('failedCopy'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      }
    },
    async checkFunnel() {
      if (this.computedUserInfo !== null) {
        try {
          const funnel = this.computedUserInfo['funnel']
          if (!funnel || funnel === '' || funnel === 'evaluator') {
            let result = await setUserFunnel(this, 'beginner')
            this.$store.commit('setUserInfo', result)

            this.$store.dispatch('setFirebaseLog', {
              eventName: 'funnel_beginner',
              eventParam: {
                createdAt: Date.now(),
                methodType: 'share_meeting',
              },
            })
          }
        } catch (e) {
          console.log()
        }
      }
    },
    async createShareUrl() {
      let title = this.selectedCh.chTitle
      let content = ''
      let imgUrl = this.chLogo
      let routePayload = {
        name: 'Channel',
        params: {
          wsDomain: this.$route.params['wsDomain'],
          chId: this.selectedCh && this.selectedCh['chId'] ? this.selectedCh['chId'].replace('CH:', '') : '',
        },
      }
      let linkUrl = location.origin + this.$router.resolve(routePayload).href
      let copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)
      this.path = copyUrl.shortLink
    },
  },
}
</script>

<style scoped>
.container-channel-header {
  display: inline-flex;
  position: relative;
  width: 100%;
  justify-content: center !important;
  background-color: #111a1e;
  color: #96a7af;
  border-radius: 10px;
  text-align: left;
}
.container-channel-header-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.container-channel-header-btns {
  text-overflow: unset;
}
.channel-header-title {
  text-transform: capitalize;
  letter-spacing: -0.5px !important;
  color: #d6dde0;
}
.channel-header-desc {
  word-break: normal;
}
.v-avatar {
  margin-top: 10px;
}
@media (max-width: 1264px) {
  /* .v-avatar {
    width: 80px !important;
    min-width: 80px !important;
    height: 80px !important;
  } */
}
@media (max-width: 959px) {
  .container-channel-header {
    width: 100%;
  }
}
/* .v-avatar:hover >>> .v-image__image {
  transition: all 0.4s;
  opacity: 0.2;
} */
.v-avatar >>> .v-image__image {
  transition: all 0.4s;
}
.show-btns {
  color: rgba(255, 255, 255, 1) !important;
  z-index: 100;
}
.channel-header-title >>> input {
  cursor: text;
}
.channel-header-title >>> .v-input__slot {
  padding: 0 !important;
}
.channel-header-desc >>> .v-input__slot {
  padding: 0 !important;
}
.channel-header-title >>> input:disabled {
  color: rgba(255, 255, 255, 1) !important;
}
.channel-header-desc >>> textarea {
  color: #ccc;
  font-size: 13px;
  line-height: 20px;
  min-height: 22px;
}
.channel-header-desc >>> .v-text-field.v-text-field--solo .v-input__control {
  min-height: 0;
}
/* .channel-header-desc >>> textarea:disabled {
  color: rgba(255, 255, 255, 1) !important;
}
.channel-header-title >>> input::placeholder {
  color: rgba(255, 255, 255, 1) !important;
} */
.container-channel-info {
  display: inline-block;
  /* width: calc(100% - 150px); */
  width: calc(100% - 150px);
  margin-left: 20px;
}
.channel-header-untitled >>> input {
  color: #666 !important;
}
@media (max-width: 1264px) {
  .channel-header-desc >>> textarea {
    font-size: 12px;
  }
}
@media (max-width: 959px) {
  .channel-header-desc >>> textarea {
    font-size: 11px;
    margin-top: 0px !important;
  }
}
.menu-channel-header >>> span {
  font-size: 20px;
  font-weight: normal;
}
.btn-link >>> i {
  font-size: 20px !important;
  font-weight: normal !important;
}
.menu-channel-header,
.btn-link {
  min-width: 36px !important;
  padding: 0px !important;
}
.btn-receive >>> span,
.btn-icon >>> span {
  font-weight: normal;
}
.container-menu-comment {
  width: 100px;
  padding: 4px;
  border-radius: 5px;
  border: 1px solid #475e69;
}
.container-menu-comment >>> .row--dense > .col {
  padding: 4px !important;
}
.container-btn .btn-control {
  width: 35px;
  height: 35px;
  background-color: transparent;
  padding: 0 !important;
  min-width: 35px !important;
}
.container-menu-comment >>> button {
  background-color: transparent !important;
}
.container-menu-comment >>> button span {
  font-size: 13px;
  font-weight: 400;
}

.container-menu-comment >>> .btn-control {
  width: 192px;
  justify-content: start;
}
.container-menu-comment >>> button:hover {
  /* border: 1px solid #666; */
  background-color: #161d21 !important;
}
.channel-header-title >>> input {
  padding: 0 !important;
}
</style>
